
import { List, Datagrid, TextField, DateField, NumberField } from 'react-admin';

export const Tbl_playerList = props => (
    <List {...props}>
        <Datagrid rowClick="edit">
            <NumberField source="id" />
            <NumberField source="teamId" />
            <NumberField source="ruoloId" />
            <TextField source="nome" />
            <TextField source="note" />
            <NumberField source="flVisibile" />
            <NumberField source="flAttivo" />
            <NumberField source="flAnnullato" />
            <NumberField source="ordinamento" />
            <DateField source="createdAt" />
            <DateField source="updatedAt" />
        </Datagrid>
    </List>
);
            